import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import {
  CustomQuery
} from '@vue-storefront/core';
import { useApiError } from '../useApiError';

export const useTransAdd = (id: string): any => {
  const { set: setError } = useApiError();
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // //console.log("useConfigcontext---------", context.useApiError);
  // Shared ref holding the response from the API
  const Res = sharedRef(null, `useTransAdd-${id}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useTransAdd-loading-${id}`);

  // Shared ref holding errors from the methods
  const error = sharedRef({}, `useTransAdd-error-${id}`);

  // Method to call an API endpoint and update `result`, `loading` and `error` properties
  const transAdd = async (params: CustomQuery) => {
    try {
      loading.value = true;
      const res = await context.$xbuy.api.transAdd(params);
      // context.useApiError.set(res);
      // console.log('翻译添加---------------------', res, params);
      if (res && res.code === 0) {
        Res.value = res.data;
        error.value = null;
      } else {
        setError(res);
        error.value = new Error(res.message);
      }
    } catch (err) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  };
  return {
    transAdd: transAdd,
    res: computed(() => Res.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
